import { render, staticRenderFns } from "./GetPointFromQR.vue?vue&type=template&id=1787655f&scoped=true&"
import script from "./GetPointFromQR.vue?vue&type=script&lang=ts&"
export * from "./GetPointFromQR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1787655f",
  null
  
)

export default component.exports